export default "__VITE_ASSET__DTWOlIPU__"